module.exports = __webpack_public_path__ + "catalog/items/bathroom/bathroom-sink/bathroom-sink.svg";